import { useGetScheduleWork } from '@entities/scheduleWork';
import type { SelectProps } from '@mantine/core';
import { FormSelect } from '@shared/ui';

type CandidateScheduleWorksSelectProps = Pick<
  SelectProps,
  'onChange' | 'value'
>;

export const CandidateScheduleWorksSelect = ({
  value,
  onChange,
}: CandidateScheduleWorksSelectProps) => {
  const { data: scheduleWorks, isError, isLoading } = useGetScheduleWork();

  return (
    <FormSelect
      variant='column'
      title='График работы'
      description=''
      aria-label='График работы'
      placeholder='Все'
      data={scheduleWorks?.map(scheduleWork => ({
        label: scheduleWork.name,
        value: scheduleWork.id.toString(),
      }))}
      disabled={isLoading || isError}
      value={value}
      onChange={onChange}
      containerProps={{ gap: 4, flex: 1 }}
    />
  );
};
